
<meta name="robots" content="noindex,nofollow" />
<meta name="viewport" content="width=device-width; initial-scale=1.0;" />

<!-- Header -->
<div>
<table
    width="100%"
    border="0"
    cellpadding="0"
    cellspacing="0"
    align="center"
    class="fullTable"
    bgcolor="#e1e1e1"
    style="border-radius: 10px;"

>
    <!-- <tr>
        <td height="20"></td>
    </tr> -->

    <tr>
        <td>
            <table
                width="100%"
                border="0"
                cellpadding="0"
                cellspacing="0"
                align="center"
                class="fullTable"
                bgcolor="#ffffff"
                style="border-radius: 10px 10px 0 0"
            >
                <tr class="hiddenMobile">
                    <!-- <td height="40"></td> -->
                    <td height="20"></td>
                </tr>
                <tr class="visibleMobile">
                    <td height="30"></td>
                </tr>

                <tr>
                    <td>
                        <table
                            width="500"
                            border="0"
                            cellpadding="0"
                            cellspacing="0"
                            align="center"
                            class="fullPadding"
                        >
                            <tbody>
                                <tr>
                                    <td>
                                        <div style="text-align: right;">
                                            <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>

                                        </div>
                                        <br/>
                                        <table
                                            width="220"
                                            border="0"
                                            cellpadding="0"
                                            cellspacing="0"
                                            align="left"
                                            class="col"
                                        >
                                            <tbody>
                                                <tr>
                                                </tr>
                                                <tr>
                                                    <td align="left">
                                                        <!-- <img
                                                            src="https://s33.postimg.org/cvidq4j7z/web_signature_01.gif"
                                                            width="82"
                                                            height="52"
                                                            alt="logo"
                                                            border="0"
                                                        /> -->
                                                        <div class="logo">
                                                            <a><h3 class="name-project">CityDiscovery</h3></a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr class="hiddenMobile">
                                                    <td height="40"></td>
                                                </tr>
                                                <tr class="visibleMobile">
                                                    <td height="20"></td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        style="
                                                            font-size: 13px;
                                                            color: #5b5b5b;
                                                            font-family: 'Open Sans',
                                                                sans-serif;
                                                            line-height: 18px;
                                                            vertical-align: top;
                                                            text-align: left;
                                                        "
                                                    >
                                                        {{'customer' | translate}}: {{customerData?.fullName}}.
                                                        <br />
                                                        ({{customerData?.email}})
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table
                                            width="220"
                                            border="0"
                                            cellpadding="0"
                                            cellspacing="0"
                                            align="right"
                                            class="col"
                                        >
                                            <tbody>
                                                <tr class="visibleMobile">
                                                    <td height="20"></td>
                                                </tr>
                                                <tr>
                                                    <td height="5"></td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        style="
                                                            font-size: 21px;
                                                            color: #ff7221;
                                                            letter-spacing: -1px;
                                                            font-family: 'Open Sans',
                                                                sans-serif;
                                                            line-height: 1;
                                                            vertical-align: top;
                                                            text-align: right;
                                                        "
                                                    >
                                                        {{'bill' | translate}}
                                                    </td>
                                                </tr>
                                                <tr></tr>
                                                <tr class="hiddenMobile">
                                                    <td height="50"></td>
                                                </tr>
                                                <tr class="visibleMobile">
                                                    <td height="20"></td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        style="
                                                            font-size: 13px;
                                                            color: #5b5b5b;
                                                            font-family: 'Open Sans',
                                                                sans-serif;
                                                            line-height: 18px;
                                                            vertical-align: top;
                                                            text-align: right;
                                                        "
                                                    >
                                                        <small> {{'billCode' | translate}} </small>
                                                        <br />{{this.uuid}}<br />
                                                        <small
                                                            > {{today | date:'medium' }} </small>


                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </table>
        </td>
    </tr>
</table>
<!-- /Header -->
<!-- Order Details -->
<table width="100%" border="0" cellpadding="0" cellspacing="0" align="center" class="fullTable" bgcolor="#e1e1e1"
>
    <tbody>
      <tr>
        <td>
          <table width="100%" border="0" cellpadding="0" cellspacing="0" align="center" class="fullTable" bgcolor="#ffffff">
            <tbody>
              <tr>
              <tr class="hiddenMobile">
                <td height="60"></td>
              </tr>
              <tr class="visibleMobile">
                <td height="40"></td>
              </tr>
              <tr>
                <td>
                  <table width="500" border="0" cellpadding="0" cellspacing="0" align="center" class="fullPadding">
                    <tbody>
                      <tr>
                        <th style="font-size: 13px; font-family: 'Open Sans', sans-serif; color: #5b5b5b; font-weight: normal; line-height: 1; vertical-align: top; padding: 0 10px 7px 0;" width="52%" align="left">
                          Quest
                        </th>
                        <th style="font-size: 13px; font-family: 'Open Sans', sans-serif; color: #5b5b5b; font-weight: normal; line-height: 1; vertical-align: top; padding: 0 0 7px;" align="left">
                          <small style="font-size: 13px;"> {{'price' | translate}} </small>
                        </th>
                        <th style="text-align: center; font-size: 13px; font-family: 'Open Sans', sans-serif; color: #5b5b5b; font-weight: normal; line-height: 1; vertical-align: top; padding: 0 0 7px;" align="center">
                          {{'quantity' | translate}}
                        </th>
                        <th style="text-align: right; font-size: 13px; font-family: 'Open Sans', sans-serif; color: #1e2b33; font-weight: normal; line-height: 1; vertical-align: top; padding: 0 0 7px;" align="right">
                          {{'provisional' | translate}}
                        </th>
                      </tr>
                      <tr>
                        <td height="1" style="background: #bebebe;" colspan="4"></td>
                      </tr>
                      <tr>
                        <td height="10" colspan="4"></td>
                      </tr>
                      <tr>
                        <td style="font-size: 13px; font-family: 'Open Sans', sans-serif; color: #ff7221;  line-height: 18px;  vertical-align: top; padding:10px 0;" class="article">
                          {{quest["title"]}}
                        </td>
                        <td style="font-size: 13px; font-family: 'Open Sans', sans-serif; color: #646a6e;  line-height: 18px;  vertical-align: top; padding:10px 0;"><small style="font-size: 13px;">{{quest["price"] | number}} đ</small></td>
                        <td style="font-size: 13px; font-family: 'Open Sans', sans-serif; color: #646a6e;  line-height: 18px;  vertical-align: top; padding:10px 0;" align="center">{{quantity}}</td>
                        <td style="font-size: 13px; font-family: 'Open Sans', sans-serif; color: #1e2b33;  line-height: 18px;  vertical-align: top; padding:10px 0;" align="right">{{quest["price"] * quantity| number}} đ</td>
                      </tr>
                      <tr>
                        <td height="1" colspan="4" style="border-bottom:1px solid #e4e4e4"></td>
                      </tr>
                      <tr>
                        <!-- <td style="font-size: 13px; font-family: 'Open Sans', sans-serif; color: #efc729;  line-height: 18px;  vertical-align: top; padding:10px 0;" class="article">Hoda Magazine title #2</td>
                        <td style="font-size: 13px; font-family: 'Open Sans', sans-serif; color: #646a6e;  line-height: 18px;  vertical-align: top; padding:10px 0;"><small>Farsi</small></td>
                        <td style="font-size: 13px; font-family: 'Open Sans', sans-serif; color: #646a6e;  line-height: 18px;  vertical-align: top; padding:10px 0;" align="center">1</td>
                        <td style="font-size: 13px; font-family: 'Open Sans', sans-serif; color: #1e2b33;  line-height: 18px;  vertical-align: top; padding:10px 0;" align="right">$325.00</td> -->
                      </tr>
                      <tr>
                        <td height="1" colspan="4" style="border-bottom:1px solid #e4e4e4"></td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td height="20"></td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
<!-- /Order Details -->
<!-- Total -->
<table
    width="100%"
    border="0"
    cellpadding="0"
    cellspacing="0"
    align="center"
    class="fullTable"
    bgcolor="#e1e1e1"
>
    <tbody>
        <tr>
            <td>
                <table
                    width="100%"
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    align="center"
                    class="fullTable"
                    bgcolor="#ffffff"
                >
                    <tbody>
                        <tr>
                            <td>
                                <!-- Table Total -->
                                <table
                                    width="500"
                                    border="0"
                                    cellpadding="0"
                                    cellspacing="0"
                                    align="center"
                                    class="fullPadding"
                                >
                                    <tbody>
                                        <tr *ngIf="isVoucher">
                                            <td
                                                style="
                                                    font-size: 13px;
                                                    font-family: 'Open Sans',
                                                        sans-serif;
                                                    color: #646a6e;
                                                    line-height: 22px;
                                                    vertical-align: top;
                                                    text-align: right;
                                                "
                                            >
                                                {{'voucher' | translate}} {{resVoucherChecking?.numOfDiscount}}%
                                            </td>
                                            <td
                                                style="
                                                    font-size: 13px;
                                                    font-family: 'Open Sans',
                                                        sans-serif;
                                                    color: #646a6e;
                                                    line-height: 22px;
                                                    vertical-align: top;
                                                    text-align: right;
                                                    white-space: nowrap;
                                                "
                                                width="80"
                                            >
                                            - {{(quest["price"] * quantity) - total | number }} đ
                                            </td>
                                        </tr>
                                        <tr>
                                            <!-- <td
                                                style="
                                                    font-size: 13px;
                                                    font-family: 'Open Sans',
                                                        sans-serif;
                                                    color: #646a6e;
                                                    line-height: 22px;
                                                    vertical-align: top;
                                                    text-align: right;
                                                "
                                            >
                                                Shipping &amp; Handling
                                            </td>
                                            <td
                                                style="
                                                    font-size: 13px;
                                                    font-family: 'Open Sans',
                                                        sans-serif;
                                                    color: #646a6e;
                                                    line-height: 22px;
                                                    vertical-align: top;
                                                    text-align: right;
                                                "
                                            >
                                                Nil
                                            </td> -->
                                        </tr>
                                        <tr>
                                            <td
                                                style="
                                                    font-size: 13px;
                                                    font-family: 'Open Sans',
                                                        sans-serif;
                                                    color: #000;
                                                    line-height: 22px;
                                                    vertical-align: top;
                                                    text-align: right;
                                                "
                                            >
                                                <strong> {{'total' | translate}} </strong>

                                            </td>
                                            <td
                                                style="
                                                    font-size: 13px;
                                                    font-family: 'Open Sans',
                                                        sans-serif;
                                                    color: #000;
                                                    line-height: 22px;
                                                    vertical-align: top;
                                                    text-align: right;
                                                "
                                                width="80"

                                            >
                                                <strong>{{total | number}} đ</strong>

                                            </td>
                                        </tr>
                                        <tr>
                                            <!-- <td
                                                style="
                                                    font-size: 13px;
                                                    font-family: 'Open Sans',
                                                        sans-serif;
                                                    color: #b0b0b0;
                                                    line-height: 22px;
                                                    vertical-align: top;
                                                    text-align: right;
                                                "
                                            >
                                                <small>TAX</small>
                                            </td>
                                            <td
                                                style="
                                                    font-size: 13px;
                                                    font-family: 'Open Sans',
                                                        sans-serif;
                                                    color: #b0b0b0;
                                                    line-height: 22px;
                                                    vertical-align: top;
                                                    text-align: right;
                                                "
                                            >
                                                <small>$72.40</small>
                                            </td> -->
                                        </tr>
                                        <tr>
                                            <td
                                                style="
                                                    font-size: 13px;
                                                    font-family: 'Open Sans',
                                                        sans-serif;
                                                    color: #b0b0b0;
                                                    line-height: 22px;
                                                    vertical-align: top;
                                                    text-align: right;
                                                "
                                            >
                                                <small></small>
                                            </td>
                                            <td
                                                style="
                                                    font-size: 13px;
                                                    font-family: 'Open Sans',
                                                        sans-serif;
                                                    color: #b0b0b0;
                                                    line-height: 22px;
                                                    vertical-align: top;
                                                    text-align: right;
                                                "
                                            >
                                                <small></small>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- /Table Total -->
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </tr>
    </tbody>
</table>
<!-- /Total -->
<!-- Information -->
<table
    width="100%"
    border="0"
    cellpadding="0"
    cellspacing="0"
    align="center"
    class="fullTable"
    bgcolor="#e1e1e1"
>
    <tbody>
        <tr>
            <td>
                <table
                    width="100%"
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    align="center"
                    class="fullTable"
                    bgcolor="#ffffff"
                >
                    <tbody>
                        <tr></tr>
                        <tr class="hiddenMobile">
                            <td height="60"></td>
                        </tr>
                        <tr class="visibleMobile">
                            <td height="40"></td>
                        </tr>
                        <tr>
                            <td>
                                <table
                                    width="500"
                                    border="0"
                                    cellpadding="0"
                                    cellspacing="0"
                                    align="center"
                                    class="fullPadding"
                                >
                                    <tbody>
                                        <tr>
                                            <td>
                                                <table
                                                    width="220"
                                                    border="0"
                                                    cellpadding="0"
                                                    cellspacing="0"
                                                    align="left"
                                                    class="col"
                                                >
                                                    <tbody>
                                                        <tr>
                                                            <td
                                                                style="
                                                                    font-size: 11px;
                                                                    font-family: 'Open Sans',
                                                                        sans-serif;
                                                                    color: #5b5b5b;
                                                                    line-height: 1;
                                                                    vertical-align: top;
                                                                "
                                                            >
                                                                <strong> {{'companyInfo' | translate}} </strong>

                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                width="100%"
                                                                height="10"
                                                            ></td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                style="
                                                                    font-size: 13px;
                                                                    font-family: 'Open Sans',
                                                                        sans-serif;
                                                                    color: #5b5b5b;
                                                                    line-height: 20px;
                                                                    vertical-align: top;
                                                                "
                                                            >
                                                                {{'col1_footer_1' | translate}}.
                                                                <!-- <br/>
                                                                Họ Tên: Nguyễn Chí Cường. -->
                                                                <br/>
                                                                {{'col1_footer_3' | translate}}.
                                                                <br/>
                                                                {{'col1_footer_4' | translate}}.
                                                                <br/>
                                                                {{'col1_footer_2' | translate}}.
                                                                <br/>
                                                                {{'national' | translate}}.

                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                                <table
                                                    width="220"
                                                    border="0"
                                                    cellpadding="0"
                                                    cellspacing="0"
                                                    align="right"
                                                    class="col"
                                                >
                                                    <tbody>
                                                        <tr
                                                            class="visibleMobile"
                                                        >
                                                            <td
                                                                height="20"
                                                            ></td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                style="
                                                                    font-size: 11px;
                                                                    font-family: 'Open Sans',
                                                                        sans-serif;
                                                                    color: #5b5b5b;
                                                                    line-height: 1;
                                                                    vertical-align: top;
                                                                "
                                                            >
                                                                <strong style="text-transform:uppercase"> {{'paymentMethod' | translate}} </strong>

                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                width="100%"
                                                                height="10"
                                                            ></td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                style="
                                                                    font-size: 13px;
                                                                    font-family: 'Open Sans',
                                                                        sans-serif;
                                                                    color: #5b5b5b;
                                                                    line-height: 20px;
                                                                    vertical-align: top;
                                                                "
                                                            >
                                                                MOMO<br />
                                                                <br /><a
                                                                    href="#"
                                                                ></a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <!-- <tr>
                            <td>
                                <table
                                    width="500"
                                    border="0"
                                    cellpadding="0"
                                    cellspacing="0"
                                    align="center"
                                    class="fullPadding"
                                >
                                    <tbody>
                                        <tr>
                                            <td>
                                                <table
                                                    width="220"
                                                    border="0"
                                                    cellpadding="0"
                                                    cellspacing="0"
                                                    align="left"
                                                    class="col"
                                                >
                                                    <tbody>
                                                        <tr
                                                            class="hiddenMobile"
                                                        >
                                                            <td
                                                                height="35"
                                                            ></td>
                                                        </tr>
                                                        <tr
                                                            class="visibleMobile"
                                                        >
                                                            <td
                                                                height="20"
                                                            ></td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                                <table
                                                    width="220"
                                                    border="0"
                                                    cellpadding="0"
                                                    cellspacing="0"
                                                    align="right"
                                                    class="col"
                                                >
                                                    <tbody>
                                                        <tr
                                                            class="hiddenMobile"
                                                        >
                                                            <td
                                                                height="35"
                                                            ></td>
                                                        </tr>
                                                        <tr
                                                            class="visibleMobile"
                                                        >
                                                            <td
                                                                height="20"
                                                            ></td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                style="
                                                                    font-size: 11px;
                                                                    font-family: 'Open Sans',
                                                                        sans-serif;
                                                                    color: #5b5b5b;
                                                                    line-height: 1;
                                                                    vertical-align: top;
                                                                "
                                                            >
                                                                <strong></strong>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                width="100%"
                                                                height="10"
                                                            ></td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                style="
                                                                    font-size: 13px;
                                                                    font-family: 'Open Sans',
                                                                        sans-serif;
                                                                    color: #5b5b5b;
                                                                    line-height: 20px;
                                                                    vertical-align: top;
                                                                "
                                                            ></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr class="hiddenMobile">
                            <td height="60"></td>
                        </tr>
                        <tr class="visibleMobile">
                            <td height="30"></td>
                        </tr> -->
                    </tbody>
                </table>
            </td>
        </tr>
    </tbody>
</table>
<!-- /Information -->
<table
    width="100%"
    border="0"
    cellpadding="0"
    cellspacing="0"
    align="center"
    class="fullTable"
    bgcolor="#e1e1e1"
    style="border-radius: 10px;"
>

    <tr>
        <td>
            <table
                width="100%"
                border="0"
                cellpadding="0"
                cellspacing="0"
                align="center"
                class="fullTable"
                bgcolor="#ffffff"
                style="border-radius: 0 0 10px 10px"
            >
                <tr>
                    <td>
                        <table
                            width="500"
                            border="0"
                            cellpadding="0"
                            cellspacing="0"
                            align="center"
                            class="fullPadding"
                        >
                            <tbody>
                                <tr>
                                    <td
                                        style="
                                            font-size: 13px;
                                            color: #5b5b5b;
                                            font-family: 'Open Sans', sans-serif;
                                            line-height: 18px;
                                            vertical-align: top;
                                            text-align: left;
                                        "
                                    >
                                        <div class="pricing-btn pt-2">
                                        <a class="default-btn" (click)="goMomo()"
                                            > {{'btn_continue' | translate}} <span></span
                                        ></a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr class="spacer">
                    <td height="20"></td>
                </tr>
            </table>
        </td>
    </tr>
    <!-- <tr>
        <td height="20"></td>
    </tr> -->
</table>
</div>
